import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { query } from "@/api/query"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/members/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { allowPrivateSpace: false })
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()
    queryClient.query(query.space.members(space)).catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "Members | Arduino Cloud"
      }
    ]
  })
})
